let API_DOMAIN
let http_domain = window.location.host
let APPID
switch(http_domain){
    case 'wxser.gdc-ds.cn'://正式环境
       API_DOMAIN = "https://wxapi.gdc-ds.cn"
       APPID = "wx59afd8e6bbd76e88"
    break;
    case 'wxtest01.gdc-ds.cn'://测试环境
       API_DOMAIN = "https://wxtest01.gdc-ds.cn/api"
       APPID = "wxa5c94a29e27c71bf"

    break;
}
export { API_DOMAIN,APPID }



//////////////////
// WEBPACK FOOTER
// ./config/apiConfig.js
// module id = 0CUL
// module chunks = 18